// Header_User.js
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { BiCart } from "react-icons/bi";
import './header-cart.css';
import { itemsCount } from '../../redux/cartSlice';
function Header_Orders() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const cart = useSelector((state) => state.cart);
  const [itemCount, setItemCount] = useState(0);
  useEffect(() => {
    dispatch(itemsCount());
  }, [user]);
  useEffect(() => {
    setItemCount(cart.count);
  }, [cart]);
  if (!user.isSignedIn) {
    return null;
  }
  return (
    <div className="header-cart">
      <Link className='cart badge-wrapper position-relative pe-2' to="/cart">
        <BiCart size="30" className="text-primary" />
        {itemCount > 0 && <span className='badge bg-danger'>{itemCount}</span>}
      </Link>
    </div>
  );
}
export default Header_Orders;
